import axiosInstance from "../../helpers/api";

export const getUserData = () => {
  return axiosInstance.get(`/userInfo`);
};

export const getNotifications = (id) => {
  return axiosInstance.get(`/students/reports/messages/${id}`);
};

export const getUserGroups = (subject_id) => {
  return axiosInstance.get(`/asquera/groups/${subject_id}`);
};